const ABFieldStringCore = require("../../core/dataFields/ABFieldStringCore");
module.exports = class ABFieldString extends ABFieldStringCore {};
